import { ModelBase } from "../shared/model.base";

export class PeriodContactability extends ModelBase {
    id: number;
    name: "";
    active: boolean;

    constructor() {
        super();
    }
}
